function input({ target: el})
{
	if (!el.required && el.value === "") {
		el.setCustomValidity("");
	}
	else if (el.value.match(/^\d{3} \d{3} \d{3}$/)) {
		el.setCustomValidity("");
	}
	else if (el.value.match(/^\d{9}$/)) {
		el.value = `${el.value.slice(0, 3)} ${el.value.slice(3, 6)} ${el.value.slice(6, 9)}`;
		el.setCustomValidity("");
	}
	else {
		el.setCustomValidity("Vennligst legg inn et gyldig organisasjonsnummer...");
	}
}

export default {
	created:   el => el.addEventListener("input", input, true),
	unmounted: el => el.removeEventListener("input", input, true)
};
